import { ZettleAuth } from "@components";
import React, { lazy, Suspense } from "react";
import { RouteObject } from "react-router";
import { Loading } from "@components";

// Lazy load the FrontView component for code splitting
const FrontView = lazy(() => import("@views").then(module => ({ default: module.FrontView })));

export const rootRoute: RouteObject = {
    path: "/",
    element: (
        <ZettleAuth>
            <Suspense fallback={<Loading />}>
                <FrontView />
            </Suspense>
        </ZettleAuth>
    ),
    children: [],
};
